import { render } from "./ChannelMatrix.vue?vue&type=template&id=a473968e"
import script from "./ChannelMatrix.vue?vue&type=script&lang=js"
export * from "./ChannelMatrix.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ChannelMatrix.vue?vue&type=style&index=0&id=a473968e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__